<script>
import { Image } from '@cf/ui-lib';
export let brand_url = '';
</script>

<div class="flex -space-x-3 rtl:space-x-reverse">
	<div
		class="w-26 group relative h-12 cursor-pointer rounded-full border-4 border-white dark:border-gray-800"
	>
		<Image class="h-full w-full" src={brand_url} />
	</div>
</div>
